'use client';
import * as React from 'react';
import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
import { SvgIcon, type SvgIconProps } from '@mui/material';
const DesktopTowerSvg = forwardRef(
  (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      ref={ref}
      {...props}
    >
      <path d="M216,72a8,8,0,0,1-8,8H176a8,8,0,0,1,0-16h32A8,8,0,0,1,216,72Zm-8,24H176a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16Zm40-48V208a16,16,0,0,1-16,16H152a16,16,0,0,1-16-16V192H96v16h16a8,8,0,0,1,0,16H64a8,8,0,0,1,0-16H80V192H32A24,24,0,0,1,8,168V96A24,24,0,0,1,32,72H136V48a16,16,0,0,1,16-16h80A16,16,0,0,1,248,48ZM136,176V88H32a8,8,0,0,0-8,8v72a8,8,0,0,0,8,8Zm96,32V48H152V208h80Zm-40-40a12,12,0,1,0,12,12A12,12,0,0,0,192,168Z" />
    </svg>
  )
);
type ComponentProps = Omit<SvgIconProps, 'inheritViewbox' | 'component'>;
function Component(
  props: ComponentProps,
  ref: React.ForwardedRef<SVGSVGElement>
) {
  return (
    <SvgIcon
      data-testid="DesktopTowerIcon"
      ref={ref}
      {...props}
      component={DesktopTowerSvg}
      inheritViewBox
    />
  );
}
Component.displayName = 'DesktopTowerIcon';
Component.muiName = SvgIcon.muiName;
export default React.memo(forwardRef(Component));
